import script from "./Optionchain.vue?vue&type=script&setup=true&lang=js"
export * from "./Optionchain.vue?vue&type=script&setup=true&lang=js"

import "./Optionchain.vue?vue&type=style&index=0&id=df2affe6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df2affe6"]])

export default __exports__